module.exports = __webpack_public_path__ + "img/II-27.e70cc208.svg";